angular.module('elfium').directive('userRegister', ['elfiumUrlService', function (elfiumUrlService) {
    return {
        restrict: 'E',
        scope: {},
        controller: 'userController',
        templateUrl: elfiumUrlService.getTemplateUrl('user', 'userRegister')
    };
}]);


// WEBPACK FOOTER //
// ./src/app/components/user/userRegister.ts